
import { INodeTemplate } from "@/types/node";

const nodeTemplates: INodeTemplate[] = [{
  category: 'CONTROL',
  name: '输入',
  code: 'START',
}, {
  category: 'CONTROL',
  name: '输出',
  code: 'END',
}, {
  category: 'CONTROL',
  name: '消息',
  code: 'MESSAGE',
}, {
  category: 'LOGIC',
  name: '条件判断',
  code: 'SWITCH',
}, {
  category: 'LOGIC',
  name: '意图识别',
  code: 'CLASSIFICATION',
}, {
  category: 'LOGIC',
  name: '批处理',
  code: 'ITERATOR',
}, {
  category: 'EXTERNAL',
  name: '大模型',
  code: 'PROMPT_TEMPLATE',
}, {
  category: 'EXTERNAL',
  name: '智能体',
  code: 'SKILL',
}, {
  category: 'EXTERNAL',
  name: '智能体',
  code: 'AGENT',
  hidden: true,
}, {
  category: 'MEMORY',
  name: '混合检索',
  hidden: true,
  code: 'SEARCH_MIX',
}, {
  category: 'MEMORY',
  name: 'FAQ检索',
  hidden: true,
  code: 'SEARCH_KNOWLEDGE',
}, {
  category: 'MEMORY',
  name: '文档检索',
  hidden: true,
  code: 'SEARCH_DOCUMENT',
}, {
  category: 'MEMORY',
  name: '知识检索',
  code: 'SEARCH_UNSTRUCTURED',
}, {
  category: 'MEMORY',
  name: '结构化检索',
  code: 'SEARCH_STRUCTURE',
}, {
  category: 'PLUGIN',
  name: '插件',
  code: 'PLUGIN_TOOL',
}, {
  category: 'PLUGIN',
  name: 'MCP',
  code: 'PLUGIN_MCP',
}, {
  category: 'DEV_TOOL',
  name: 'HTTP调用',
  code: 'API_AGENT',
}, {
  category: 'DEV_TOOL',
  name: '代码',
  code: 'SCRIPT',
}, {
  category: 'TEXT_TOOL',
  name: '联网搜索',
  code: 'NET_SEARCH',
}, {
  category: 'TEXT_TOOL',
  name: '简体转繁体',
  code: 'TOOL',
  toolCode: 'simple2Traditional',
}, {
  category: 'TEXT_TOOL',
  name: '繁体转简体',
  code: 'TOOL',
  toolCode: 'traditional2Simple',
}, {
  category: 'TEXT_TOOL',
  name: '表格生成',
  code: 'TOOL',
  toolCode: 'table_doc_save',
}, {
  category: 'TEXT_TOOL',
  name: '语言识别',
  code: 'LANGUAGE_DETECTOR',
}, {
  category: 'TEXT_TOOL',
  name: '文字识别',
  code: 'OCR',
}, {
  category: 'IMAGE_TOOL',
  name: '图片生成',
  code: 'TOOL',
  toolCode: 'pic_generator',
}, {
  category: 'VOICE_TOOL',
  name: '语音识别',
  code: 'ASR',
}, {
  category: 'VOICE_TOOL',
  name: '语音合成',
  code: 'TTS',
}];

const formatType = (type: string) => {
  if (type === 'RESPONSE') {
    return 'END';
  }
  if (type === 'START_NODE' || type === 'INPUT') {
    return 'START';
  }
  return type;
};

const nodeTemplateMap = nodeTemplates.reduce<Record<string, INodeTemplate>>((acc, tpl) => {
  if (tpl.toolCode) {
    acc[tpl.toolCode] = tpl;
  }
  acc[tpl.code] = tpl;
  return acc;
}, {});


export function getNodeTemplate(type: string, code?: string) {
  type = formatType(type);
  if (code) {
    return nodeTemplateMap[code] || nodeTemplateMap[type];
  }
 return nodeTemplateMap[type];
}
